import { UseDisclosureReturn } from "@chakra-ui/react";
import { FieldProps } from "@rjsf/utils";
import { FormattedMessage } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import { DatasetOverview } from "@/lib/catalogue/features/dataset";

type ProjectProcessRunFormDatasetSelectorModalProps = UseDisclosureReturn &
  FieldProps<{ id: string; input_type: "dataset" }>;

export const ProjectProcessRunFormDatasetSelectorModal = (
  props: ProjectProcessRunFormDatasetSelectorModalProps
) => {
  const {
    isOpen,
    onClose,
    onChange,
    schema: { rana_widget: { filters } = {} },
  } = props;
  const category: string | undefined = filters["cl_topic.key"];
  const spatialRepresentationType: string | undefined = filters["cl_spatialRepresentationType.key"];

  return (
    <RanaModal
      topBar={
        <FormattedMessage
          id="heading.select_dataset"
          defaultMessage="Select {category} dataset"
          values={{ category: category?.toLocaleLowerCase() }}
        />
      }
      w="full"
      h="full"
      isOpen={isOpen}
      onClose={onClose}
    >
      <DatasetOverview
        disableSettingSearchParams
        fixedCategory={category}
        fixedSpatialRepresentationType={spatialRepresentationType}
        goToExtractDatasetProcess={(params) => {
          onClose();

          if (!("datasetId" in params)) throw Error("datasetId should be in params");

          onChange({ id: params.datasetId, input_type: "dataset" });
        }}
      />
    </RanaModal>
  );
};
